var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGefionFacility13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 80,
    viewBox: "0 0 71 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V80H70.6177V0H0ZM65.9302 4.6875V18.7653H4.6875V4.6875H65.9302ZM4.6875 75.3125V23.4528H65.9302V75.3125H4.6875Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38086 9.38232H15.6357V14.0698H9.38086V9.38232Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3281 9.38232H26.583V14.0698H20.3281V9.38232Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0352 9.38232H61.2361V14.0698H44.0352V9.38232Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3087 28.1401C24.3877 28.1401 15.3667 36.4244 14.196 47.0385H9.37305V51.726H14.196C15.3667 62.3406 24.3877 70.6249 35.3087 70.6249C47.022 70.6249 56.5514 61.0955 56.5514 49.3822C56.5514 37.6696 47.022 28.1401 35.3087 28.1401ZM35.3087 65.9374C26.9756 65.9374 20.0621 59.7484 18.9202 51.726H23.6748C24.7661 57.1514 29.5671 61.2499 35.3087 61.2499C41.8523 61.2499 47.1764 55.9264 47.1764 49.3822C47.1764 42.8386 41.8523 37.5151 35.3087 37.5151C29.5671 37.5151 24.7661 41.6136 23.6748 47.0385H18.9202C20.0621 39.016 26.9756 32.8276 35.3087 32.8276C44.4371 32.8276 51.8633 40.2538 51.8633 49.3822C51.8633 58.5106 44.4371 65.9374 35.3087 65.9374ZM28.1285 49.3822C28.1285 45.4235 31.3494 42.2026 35.3087 42.2026C39.2675 42.2026 42.4889 45.4235 42.4889 49.3822C42.4889 53.3416 39.2675 56.5624 35.3087 56.5624C31.3494 56.5624 28.1285 53.3416 28.1285 49.3822Z",
    fill: "#C49A36"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGefionFacility13);
export default __webpack_public_path__ + "static/media/gefion-facility-13.f2ae66a9.svg";
export { ForwardRef as ReactComponent };